import { APIMethod, fetchData } from "@client";

export function exchangeImpersonationCode(code) {
  return fetchData("/auth/impersonation/exchange", APIMethod.POST, {
    data: { code },
    isJSONData: true,
    noAuth: true,
    returnFullResponse: true,
    skipTokenPersistence: true,
  });
}

export function revokeImpersonationSession(sessionId) {
  return fetchData(
    `/auth/impersonation/${encodeURIComponent(sessionId)}/revoke`,
    APIMethod.POST,
    { returnFullResponse: true },
  );
}
